// Prod appconfig.js for leap-admin-panel
export default {
  cardpaging:100,  
  tablepaging:100, 
  //baseurl:"http://localhost:1019"
  //baseurl:"http://10.0.1.202:4044"
  baseurl:"https://cpapi.1to1help.net",
  // maternityMemberBaseUrl:"http://localhost:3011",
  // maternityMemberAccountBaseUrl:"http://localhost:3012",
  maternityMemberBaseUrl:"https://cpapi.1to1help.net",
  maternityMemberAccountBaseUrl:"https://cpapi.1to1help.net",
  leapSponsorApiServerBaseUrl:"https://cpapi.1to1help.net",
  caseBaseUrl:"https://cpapi.1to1help.net",
  maternityEventBaseUrl:"https://cpapi.1to1help.net",
  accessurl:"https://access.1to1help.net/openam/oauth2/internal-sso/authorize?client_id=982562421580.leap-admin-sso&scope=profile%20email&response_type=token&redirect_uri=https://cp.1to1help.net/auth-success",
  socketUrl:"https://devsocket.1to1help.net",
  surgeNotificationBaseUrl: "https://app.1to1help.net"
  };
